export default __webpack_public_path__ + "assets/3f394bd7102b8da522047a82fd90f3e8.jpg";